module.exports = __webpack_public_path__ + "img/more-4.22b76008.svg";